module.exports = __webpack_public_path__ + "media/widget/gift_black-5f080247.svg";